import React from 'react';
import FormFieldItem, { CreateInventoryFormPanel } from './FormLayout';
import {
    Select,
    Input,
    DateInput,
    MultiSelect
} from '../Common';
import {
    asset_status_options,
    yes_no_options,
    energy_source_type_options,
    phase_options,
    hertz_options,
    device_type_options,
    ald_type_options,
    concentration_monitor_type_options,
    sensor_type_options,
} from './utils';
import PropTypes from 'prop-types';
import LocationDropdown from './LocationDropdown';

const ControlsLeakMonitoringDevice = ({
    newPurchaseAquisition,
    setNewPurchaseAquisition,
    aquireLocation,
    aquireLocationsOptions,
    setAquireLocation,
    locations,
    location,
    setLocation,
    subLocation,
    setSubLocation,
    name,
    setName,
    assetStatus,
    setAssetStatus,
    tagNumber,
    setTagNumber,
    serialNumber,
    setSerialNumber,
    acquisitionDate,
    setAquisitionDate,
    disbursementDate,
    setDisbursementDate,
    installDate,
    setInstallDate,
    deviceType,
    setDeviceType,
    aldType,
    setALDType,
    detectionLimit,
    setDetectionLimit,
    alarmPoint,
    setAlarmPoint,
    concentrationMonitorType,
    setConcentrationMonitorType,
    concentrationMonitorManufacturer,
    setConcentrationMonitorManufacturer,
    sensorType,
    setSensorType,
    numberOfSensors,
    setNumberOfSensors,
    locationOnSite,
    setLocationOnsite,
    manufacturer,
    setManufacturer,
    manufacturers,
    manufactureDate,
    setManufactureDate,
    modelNumber,
    setModelNumber,
    modelYear,
    setModelYear,
    years,
    brand,
    setBrand,
    poNumber,
    setPONumber,
    lifeTime,
    setLifeTime,
    lifeTimeOptions,
    amps,
    setAmps,
    voltage,
    setVoltage,
    hertz,
    setHertz,
    phase,
    setPhase,
    systemManagers,
    systemManager,
    setSystemManager,
    hermeticallySealed,
    setHermeticallySealed,
    energySourceType,
    setEnergySourceType,
    errorObject,
    id,
    regulatedAssets,
    regulatedAssetTypes,
    setRegulatedAssets
}) => {

    return (
        <CreateInventoryFormPanel enabled={!id}>
            {
                id == 0 && (
                    <FormFieldItem>
                        <Select
                            value={newPurchaseAquisition}
                            label={"Is this a new purchase / acquisition?"}
                            options={yes_no_options}
                            onChange={e => setNewPurchaseAquisition(e.target.value)}
                            error={errorObject.NewPurchaseAquisition}
                        />
                    </FormFieldItem>
                )
            }
            {
                newPurchaseAquisition == 1 && (
                    <FormFieldItem>
                        <Select
                            required={true}
                            value= {aquireLocation}
                            label= {"Acquired From Location"}
                            options= {aquireLocationsOptions}
                            onChange= {e => setAquireLocation(e.target.value)}
                            error= {errorObject.AquireLocation}
                        />
                    </FormFieldItem>
                )
            }
            <LocationDropdown
                required
                locations={locations}
                location={location}
                subLocation={subLocation}
                onChangeLocation={setLocation}
                onChangeSubLocation={setSubLocation}
                ErrorObject={errorObject.location}
            />
            <FormFieldItem>
                <Input
                    required
                    fullWidth 
                    label= {"Name"}
                    value={name}
                    onChange={e => setName(e.target.value)}
                    error={errorObject.Name}
                    helperText={typeof errorObject.Name === 'string' ? errorObject.Name : undefined}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    required={true}
                    value={assetStatus}
                    label= {"Asset Status"}
                    options={asset_status_options}
                    onChange={e => setAssetStatus(e.target.value)}
                    error={errorObject.AssetStatus}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    required={true}
                    fullWidth
                    label= {"Tag Number"}
                    value={tagNumber}
                    onChange={e => setTagNumber(e.target.value)}
                    error={errorObject.TagNumber}
                    helperText={typeof errorObject.TagNumber === 'string' ? errorObject.TagNumber : undefined}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    required={true}
                    fullWidth
                    label= {"Serial Number"}
                    value={serialNumber}
                    onChange={e => setSerialNumber(e.target.value)}
                    error={errorObject.SerialNumber}
                    helperText={typeof errorObject.SerialNumber === 'string' ? errorObject.SerialNumber : undefined}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    allowPast={true}
                    label={`Acquisition Date ${id ? " " : "*"}`}
                    date={acquisitionDate}
                    onChange={date => setAquisitionDate(date)}
                    error={errorObject.AcquisitionDate}
                    customHelperText={errorObject.AcquisitionDate}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    allowPast={true}
                    date={disbursementDate}
                    onChange={date => setDisbursementDate(date)}
                    label="Disbursement Date"
                    disabled={assetStatus == 1}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    allowPast={true}
                    date={installDate}
                    onChange={date => setInstallDate(date)}
                    label={`Install Date ${id ? " " : "*"}`}
                    error={errorObject.InstallDate}
                    customHelperText={errorObject.InstallDate}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    required={true}
                    label="Device Type"
                    value= {deviceType}
                    onChange={e => setDeviceType(e.target.value)}
                    options={device_type_options}
                    error={errorObject.DeviceType}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    label="ALD Type"
                    value= {aldType}
                    onChange={e => setALDType(e.target.value)}
                    options={ald_type_options}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    type={"number"}
                    fullWidth
                    label= {"Detection Limit"}
                    value={detectionLimit}
                    onChange={e => setDetectionLimit(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    type={"number"}
                    fullWidth
                    label= {"Alarm Set Point"}
                    value={alarmPoint}
                    onChange={e => setAlarmPoint(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    label="Concentration Monitor Type"
                    value= {concentrationMonitorType}
                    onChange={e => setConcentrationMonitorType(e.target.value)}
                    options={concentration_monitor_type_options}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Concentration Monitor Manufacturer"
                    value= {concentrationMonitorManufacturer}
                    onChange={e => setConcentrationMonitorManufacturer(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    label="Sensor Type"
                    value= {sensorType}
                    onChange={e => setSensorType(e.target.value)}
                    options={sensor_type_options}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    type={"number"}
                    fullWidth
                    label= {"Number of Sensors"}
                    value={numberOfSensors}
                    onChange={e => setNumberOfSensors(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label= {"Location On Site"}
                    value={locationOnSite}
                    onChange={e => setLocationOnsite(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    label="Manufacturer"
                    value= {manufacturer}
                    onChange={e => setManufacturer(e.target.value)}
                    options={manufacturers}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    allowPast={true}
                    allowFuture={true}
                    label="Manufacturer Date"
                    date={manufactureDate}
                    onChange={date => setManufactureDate(date)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label= {"Model Number"}
                    value={modelNumber}
                    onChange={e => setModelNumber(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    label="Model Year"
                    value= {modelYear}
                    onChange={e => setModelYear(e.target.value)}
                    options={years}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label= {"Brand"}
                    value={brand}
                    onChange={e => setBrand(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label= {"PO Number"}
                    value={poNumber}
                    onChange={e => setPONumber(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    label="Expected Lifetime (years)"
                    value= {lifeTime}
                    onChange={e => setLifeTime(e.target.value)}
                    options={lifeTimeOptions}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type={"number"}
                    label= {"Amps"}
                    value={amps}
                    onChange={e => setAmps(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type={"number"}
                    label= {"Voltage"}
                    value={voltage}
                    onChange={e => setVoltage(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    label="Hertz"
                    value= {hertz}
                    onChange={e => setHertz(e.target.value)}
                    options={hertz_options}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    label="Phase"
                    value= {phase}
                    onChange={e => setPhase(e.target.value)}
                    options={phase_options}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    label="System Manager"
                    value= {systemManager}
                    onChange={e => setSystemManager(e.target.value)}
                    options={systemManagers}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    label="Is Hermetically Sealed"
                    value= {hermeticallySealed}
                    onChange={e => setHermeticallySealed(e.target.value)}
                    options={yes_no_options}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    label="Energy Source Type"
                    value= {energySourceType}
                    onChange={e => setEnergySourceType(e.target.value)}
                    options={energy_source_type_options}
                />
            </FormFieldItem>
            <FormFieldItem>
                <MultiSelect
                    value={regulatedAssets}
                    label="Applicable U.S.-Based Regulations"
                    options={regulatedAssetTypes}
                    onChange={e => {
                        const {
                            target: { value },
                        } = e;
                        setRegulatedAssets(typeof value === 'string' ? value.split(',') : value);
                    }}
                />
            </FormFieldItem>
        </CreateInventoryFormPanel>
   )
};

ControlsLeakMonitoringDevice.propTypes = {
    newPurchaseAquisition: PropTypes.array.isRequired,
    setNewPurchaseAquisition: PropTypes.object.isRequired,
    newPurchaseAquisition: PropTypes.string.isRequired,
    setNewPurchaseAquisition: PropTypes.func.isRequired,
    locations: PropTypes.array.isRequired,
    location: PropTypes.string.isRequired,
    setLocation: PropTypes.func.isRequired,
    subLocation: PropTypes.string.isRequired,
    setSubLocation: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    setName: PropTypes.func.isRequired,
    assetStatus: PropTypes.string.isRequired,
    setAssetStatus: PropTypes.func.isRequired,
    tagNumber: PropTypes.string.isRequired,
    setTagNumber: PropTypes.func.isRequired,
    serialNumber: PropTypes.string.isRequired,
    setSerialNumber: PropTypes.func.isRequired,
    acquisitionDate: PropTypes.string.isRequired,
    setAquisitionDate: PropTypes.func.isRequired,
    disbursementDate: PropTypes.string.isRequired,
    setDisbursementDate: PropTypes.func.isRequired,
    installDate: PropTypes.string.isRequired,
    setInstallDate: PropTypes.func.isRequired,
    deviceType: PropTypes.string.isRequired,
    setDeviceType: PropTypes.func.isRequired,
    aldType: PropTypes.string.isRequired,
    setALDType: PropTypes.func.isRequired,
    detectionLimit: PropTypes.string.isRequired,
    setDetectionLimit: PropTypes.func.isRequired,
    alarmPoint: PropTypes.string.isRequired,
    setAlarmPoint: PropTypes.func.isRequired,
    concentrationMonitorType: PropTypes.string.isRequired,
    setConcentrationMonitorType: PropTypes.func.isRequired,
    concentrationMonitorManufacturer: PropTypes.string.isRequired,
    setConcentrationMonitorManufacturer: PropTypes.func.isRequired,
    sensorType: PropTypes.string.isRequired,
    setSensorType: PropTypes.func.isRequired,
    numberOfSensors: PropTypes.string.isRequired,
    setNumberOfSensors: PropTypes.func.isRequired,
    locationOnSite: PropTypes.string.isRequired,
    setLocationOnsite: PropTypes.func.isRequired,
    manufacturer: PropTypes.string.isRequired,
    setManufacturer: PropTypes.func.isRequired,
    manufacturers: PropTypes.array.isRequired,
    manufactureDate: PropTypes.string.isRequired,
    setManufactureDate: PropTypes.func.isRequired,
    modelNumber: PropTypes.string.isRequired,
    setModelNumber: PropTypes.func.isRequired,
    modelYear: PropTypes.string.isRequired,
    setModelYear: PropTypes.func.isRequired,
    years: PropTypes.array.isRequired,
    brand: PropTypes.string.isRequired,
    setBrand: PropTypes.func.isRequired,
    poNumber: PropTypes.string.isRequired,
    setPONumber: PropTypes.func.isRequired,
    lifeTime: PropTypes.string.isRequired,
    setLifeTime: PropTypes.func.isRequired,
    lifeTimeOptions: PropTypes.array.isRequired,
    amps: PropTypes.string.isRequired,
    setAmps: PropTypes.func.isRequired,
    voltage: PropTypes.string.isRequired,
    setVoltage: PropTypes.func.isRequired,
    hertz: PropTypes.string.isRequired,
    setHertz: PropTypes.func.isRequired,
    phase: PropTypes.string.isRequired,
    setPhase: PropTypes.func.isRequired,
    systemManager: PropTypes.string.isRequired,
    setSystemManager: PropTypes.func.isRequired,
    hermeticallySealed: PropTypes.string.isRequired,
    setHermeticallySealed: PropTypes.func.isRequired,
    energySourceType: PropTypes.string.isRequired,
    setEnergySourceType: PropTypes.func.isRequired,
    errorObject: PropTypes.object.isRequired,
    regulatedAssets: PropTypes.array.isRequired,
    regulatedAssetTypes: PropTypes.array.isRequired,
    setRegulatedAssets: PropTypes.func.isRequired
};

export default ControlsLeakMonitoringDevice;
